import type { HelpScreenFacts } from "./types";

/**
 * Ajudantes compartilhados entre telas. A regra vale pra todos: se o fato
 * não veio do backend, devolva `null` — a ajuda omite a linha em vez de
 * chutar um valor.
 */

/** Quantos dias a data de negócio está atrás de hoje. `null` se não deu pra saber. */
function diasAtrasada(businessDate: string | null | undefined): number | null {
  if (!businessDate) return null;
  const negocio = new Date(`${businessDate}T00:00:00`);
  if (Number.isNaN(negocio.getTime())) return null;

  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  return Math.round((hoje.getTime() - negocio.getTime()) / 86_400_000);
}

/**
 * Frase sobre a data de negócio — o "dia" em que o hotel está para o
 * sistema, que só avança quando a auditoria noturna roda. Atraso aqui é o
 * sintoma mais comum de diária não lançada, então vale dizer com todas as
 * letras.
 */
export function estadoDaDataDeNegocio(screen: HelpScreenFacts): string | null {
  const atraso = diasAtrasada(screen.business_date);
  if (atraso === null || !screen.business_date) return null;

  const formatada = new Date(`${screen.business_date}T00:00:00`).toLocaleDateString("pt-BR");
  if (atraso <= 0) return `data de negócio em ${formatada} — em dia.`;
  if (atraso === 1) return `data de negócio em ${formatada} — falta rodar a auditoria de ontem.`;
  return `data de negócio em ${formatada}, ${atraso} dias atrás. Enquanto a auditoria não roda, as diárias desses dias não entram no faturamento.`;
}
